var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShellsIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1085.6 1085.6",
    style: {
      enableBackground: "new 0 0 1085.6 1085.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#04222E;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_6_);}\r\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);}\r\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_8_);}\r\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_9_);}\r\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_10_);}\r\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_11_);}\r\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_12_);}\r\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_13_);}\r\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_14_);}\r\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_15_);}\r\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_16_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "bd6d4489-4481-4057-8cca-302e7d1d0ea3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ed67cb0b-4427-4885-ae2e-6dc34a4d2ad1"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -481.2,
    y: -481.3,
    className: "st0",
    width: 2048,
    height: 2048
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.9,773.1c-95.7-75.8-155.1-188.4-163.7-310.2c-4.6-78.1,13.5-155.9,52.2-223.9 C247.6,94.8,401,4.7,568.4,0.5c122-5.6,242.1,32.4,338.6,107.3l23.5,18.8c6.9,5.5,11.4,13.5,12.5,22.3c1.4,8.9-1.5,17.8-7.8,24.2 L806.3,320.4c15.4,13.4,30,29.3,43.7,43.6c149.6,152.2,170,374.1,40.3,536.6c-171.8,215-498.3,245.5-711.3,75.8l-23.5-18.8 c-13.9-11.1-16.3-31.4-5.2-45.3l0.4-1.3L273.9,773.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 634.9767,
    y1: 314.8897,
    x2: 392.9236,
    y2: 642.3647,
    gradientTransform: "matrix(1 5.462853e-03 -5.462853e-03 1 -36.9896 26.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#52BD15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A0E35D"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M734.2,317.3l142.7-163.8c-85.5-65.7-191.3-99.2-299-94.6c-224.1,9.7-413,181.4-401.2,399.1 c9.8,124.7,80.1,236.7,188.2,299.7c55.3,33.1,118.9,49.6,183.2,47.6c144.1-5.9,266.2-106,274.4-245.5 c6.1-129-97.9-260.9-243-238.5c-88.9,13.7-162.3,80.2-163.8,168.4c-0.4,53,24.2,103.2,66.4,135.3l11.3-13.3l25.1-30.1 c-19.5-17.5-30.5-42.6-30-68.8c1.7-56.6,48.7-101.2,105.3-99.9c67.3,3.3,119.4,60.2,116.7,127.5c0,5-0.7,10-2,14.8 c-11.5,70.6-73,122.1-144.5,121.2c-36.2,1.3-71.9-9.2-101.6-29.8c-49.8-38-79.2-96.7-79.9-159.3c0-18.2,2.7-36.3,8.2-53.6 c5.1-16.9,12.4-33,21.8-47.9c9.4-14.8,20.6-28.4,33.3-40.5c12.9-12.2,27.3-22.9,42.7-31.7c15.9-9.1,32.7-16.3,50.2-21.6 c18-5.5,36.5-8.9,55.3-10.1c24.3-1.1,48.7,1.6,72.2,8C690.1,295.8,713,305,734.2,317.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 538.2722,
    y1: 909.5004,
    x2: 914.1622,
    y2: 490.8892,
    gradientTransform: "matrix(1 5.462853e-03 -5.462853e-03 1 -36.9896 26.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#52BD15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A0E35D"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M346.9,787l-123,142.1c85.7,67.2,192.8,101.1,301.6,95.4c125.9-2.3,244.4-60.1,323.8-157.9l2.5-3.4 c28.7-36.2,50.1-77.6,63.1-121.9C940,619.5,902.3,493.2,814.5,405c39.6,61.6,51.6,136.9,33.2,207.7 C814.4,747,690,832.3,548.8,837.7C478,841.5,407.6,823.8,346.9,787z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 890.7029,
    y1: 535.155,
    x2: 454.1923,
    y2: 923.5388,
    gradientTransform: "matrix(0.9997 2.504286e-02 -2.504286e-02 0.9997 -46.0249 32.0971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M223.9,929.2c98.5,76.3,223.7,109.4,347.1,91.8l4.3-185.3c-79.4,9-159.5-8-228.3-48.6L223.9,929.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 700.7606,
    y1: 469.1077,
    x2: 342.2786,
    y2: 598.214,
    gradientTransform: "matrix(1 8.000000e-03 -8.000000e-03 1 -43.5141 30.6269)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M185.4,513.7c23.8,104.8,90.9,194.6,184.7,247.1l95.1-112.2c-46.4-34.4-76-86.8-81.6-144.3L185.4,513.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.945,
    y1: 545.8505,
    x2: 463.811,
    y2: 133.363,
    gradientTransform: "matrix(1 5.462853e-03 -5.462853e-03 1 -36.9896 26.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M421.4,373c39.7-51.4,98.9-84.2,163.6-90.4l-1.7-224c-135.7,3.9-262.2,69.9-343,179L421.4,373z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.8993,
    y1: 684.863,
    x2: 292.9648,
    y2: 315.0155,
    gradientTransform: "matrix(1 5.462853e-03 -5.462853e-03 1 -36.9896 26.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M421.5,372.9L240.4,237.5c-57.1,79.8-77.2,180.4-55,276l198.2-9.3C379.3,457.3,392.8,410.4,421.5,372.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 462.6544,
    y1: 259.8392,
    x2: 621.3744,
    y2: 433.5505,
    gradientTransform: "matrix(1 5.462853e-03 -5.462853e-03 1 -36.9896 26.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M776.3,405.5C732.4,342,656,309.3,579.7,321.2c-88.9,13.6-162.3,80.2-163.9,168.4 c-0.4,53,24.2,103.2,66.4,135.3l6.7-7.7c-54.9-61.3-57.8-166.4,8.2-214.2c111.8-80.9,244-14.6,284.7,104.1 c13.3,42.7,21.3,86.9,23.9,131.6C836,561,825,473.2,776.3,405.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 751.2245,
    y1: 500.4521,
    x2: 764.3726,
    y2: 921.4396,
    gradientTransform: "matrix(0.9999 -1.272311e-02 1.272311e-02 0.9999 -34.9272 24.9808)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M571,1020.9c106.4-13.2,203.9-66.1,273.1-148l5.3-6.1c24.7-30.8,44.3-65.4,58-102.4l-89.3-78 C764.7,771.1,675,826.2,575.4,835.7L571,1020.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 724.861,
    y1: 347.7212,
    x2: 991.101,
    y2: 681.4837,
    gradientTransform: "matrix(1 5.462853e-03 -5.462853e-03 1 -36.9896 26.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M818,686.3l89.3,78c1.6-5.1,5.5-16.6,7.1-21.7c25.7-122.2-11.8-249-99.9-337.5 c39.8,62,52.2,137.8,34.1,209.3C840.9,639.3,830.7,663.4,818,686.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1096.5449,
    y1: 1332.9199,
    x2: 607.6054,
    y2: 696.9137,
    gradientTransform: "matrix(1 5.462853e-03 -5.462853e-03 1 -36.9896 26.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M223.9,929.2c85.7,67.2,192.8,101.1,301.6,95.4c125.9-2.5,244.3-60.2,323.8-157.9l2.5-3.4 c28.7-36.2,50.1-77.6,63.1-121.9c3.7-15.3,5.9-31,6.5-46.7c1.2-15.7,1.3-31.4,0.5-47.1c-4.6-91.2-42.8-177.5-107.2-242.2 c3.4,4.4,6.5,9,9.3,13.9c20.6,29.2,37.6,60.8,50.4,94.2c12.2,32.6,19,67,20.3,101.7v1c0,1,0,2,0,3.2c0.4,15-0.2,30-1.7,44.9 c-1,14.8-3.4,29.6-7,44c-12,40.8-31.9,78.9-58.5,112.1l-2.5,3.4C751,913.3,642.1,966.5,526.1,970c-95.8,4-190.1-24.4-267.6-80.7 L223.9,929.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 838.396,
    y1: 375.5638,
    x2: 336.1855,
    y2: 1162.2214,
    gradientTransform: "matrix(1 5.462853e-03 -5.462853e-03 1 -36.9896 26.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M522.6,880c155.5-6.4,291.4-100.7,327-246.9c23.7-77.4,10.7-161.4-35.2-228.1 c39.2,61.7,51.2,136.9,33.3,207.7c-33.3,134.3-156,218.6-298.8,225C478.1,840.6,408,823,347,787l-36.5,41.9 C375.1,865.3,448.5,883,522.6,880z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 527.144,
    y1: 440.3058,
    x2: 761.7014,
    y2: 83.7696,
    gradientTransform: "matrix(1 5.462853e-03 -5.462853e-03 1 -36.9896 26.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M585.1,282.6l-1.6-224.1C689.3,55.4,793,88.9,877,153.3L734.3,317.1C689,291.1,637.1,279.1,585.1,282.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 1283.5649,
    y1: 1167.265,
    x2: 779.6136,
    y2: 983.9075,
    gradientTransform: "matrix(0.9522 0.3056 -0.3056 0.9522 112.073 -609.5679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M810.3,623.2c-7.2,19.3-16.1,37.9-26.6,55.7c-24.1,36.8-57.1,66.9-95.9,87.5c-37.9,21.2-79.9,34-123.1,37.5 c-37.4,3-74.9-0.1-111.3-9.1c-7.7-1.9-15.3-4.1-22.8-6.5c-23.3-7.8-45.7-18.1-66.7-30.7c-21.2-12.5-41.1-27.1-59.4-43.6 c-17.5-15.1-33.4-32-47.5-50.4c-2.7-3.7-5.3-7.4-7.9-11.1c-2.6-4-5.5-7.8-8.6-11.4c15.4,17.5,32.6,33.4,51.2,47.5 c10.5,8,21.4,15.5,32.8,22.2c5,3.2,10.2,6.1,15.6,8.8c6.8,3.7,14,7.2,21.3,10.4c3.9,1.8,8,3.4,12.2,5c6.9,2.8,14,5.3,21.2,7.6 c5.4,1.7,10.8,3.3,16.2,4.8c10.6,2.8,21.3,5.2,32.1,6.9c47.8,8,96.9,5.4,143.6-7.5c2-0.5,4-1,5.8-1.5c8.1-2.2,16.1-4.8,23.9-7.9 c0.3,0,0.6-0.1,0.8-0.3C727.6,692.7,781,567.2,736.6,456.8c-17.9-44.5-50.1-81.7-91.6-105.8c-13.4-7.9-27.6-14.3-42.4-19l-1-0.3 c-11.7-3.7-23.7-6.4-35.9-8c8.2-2,16.6-2.3,24.9-3.6c18.3-1.4,36.6-0.9,54.7,1.7c6.1,1.4,12.5,2,18.4,4.1 c24.8,7.5,48,19.3,68.6,35c4.1,3.2,10.4,8.5,14.3,12.2c4.4,4,8.7,8.3,12.6,12.7c0.8,0.8,3.3,3.7,4.1,4.6 c31.3,36.7,51.4,81.6,57.8,129.4c1.6,11.3,2.1,22.7,1.6,34.1C821.8,577.3,817.6,600.7,810.3,623.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.9275,
    y1: 169.5375,
    x2: 591.0667,
    y2: 383.43,
    gradientTransform: "matrix(1 5.462853e-03 -5.462853e-03 1 -36.9896 26.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M877,153.4c-85.5-65.7-191.3-99.2-299-94.6c-224.1,9.7-413,181.4-401.2,399.1 c9.8,124.7,80.1,236.7,188.1,299.7c42.1,25.3,89.2,41.1,138,46.5c12.6,1.2,25.3,1.7,38.1,1.6c-157.3-5.4-292.4-145.9-301.4-302.2 c-10.6-190.6,155.6-340,349.6-348.2c81.8-3.1,162.6,18.6,231.9,62.3L877,153.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1283.5649,
    y1: 1167.265,
    x2: 779.6136,
    y2: 983.9075,
    gradientTransform: "matrix(0.9522 0.3056 -0.3056 0.9522 112.073 -609.5679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M810.3,623.2c-7.2,19.3-16.1,37.9-26.6,55.7c-24.1,36.8-57.1,66.9-95.9,87.5c-37.9,21.2-79.9,34-123.1,37.5 c-37.4,3-74.9-0.1-111.3-9.1c-7.7-1.9-15.3-4.1-22.8-6.5c-23.3-7.8-45.7-18.1-66.7-30.7c-21.2-12.5-41.1-27.1-59.4-43.6 c-17.5-15.1-33.4-32-47.5-50.4c-2.7-3.7-5.3-7.4-7.9-11.1c-2.6-4-5.5-7.8-8.6-11.4c15.4,17.5,32.6,33.4,51.2,47.5 c10.5,8,21.4,15.5,32.8,22.2c5,3.2,10.2,6.1,15.6,8.8c6.8,3.7,14,7.2,21.3,10.4c3.9,1.8,8,3.4,12.2,5c6.9,2.8,14,5.3,21.2,7.6 c5.4,1.7,10.8,3.3,16.2,4.8c10.6,2.8,21.3,5.2,32.1,6.9c47.8,8,96.9,5.4,143.6-7.5c2-0.5,4-1,5.8-1.5c8.1-2.2,16.1-4.8,23.9-7.9 c0.3,0,0.6-0.1,0.8-0.3C727.6,692.7,781,567.2,736.6,456.8c-17.9-44.5-50.1-81.7-91.6-105.8c-13.4-7.9-27.6-14.3-42.4-19l-1-0.3 c-11.7-3.7-23.7-6.4-35.9-8c8.2-2,16.6-2.3,24.9-3.6c18.3-1.4,36.6-0.9,54.7,1.7c6.1,1.4,12.5,2,18.4,4.1 c24.8,7.5,48,19.3,68.6,35c4.1,3.2,10.4,8.5,14.3,12.2c4.4,4,8.7,8.3,12.6,12.7c0.8,0.8,3.3,3.7,4.1,4.6 c31.3,36.7,51.4,81.6,57.8,129.4c1.6,11.3,2.1,22.7,1.6,34.1C821.8,577.3,817.6,600.7,810.3,623.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.9275,
    y1: 169.5375,
    x2: 591.0667,
    y2: 383.43,
    gradientTransform: "matrix(1 5.462853e-03 -5.462853e-03 1 -36.9896 26.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M877,153.4c-85.5-65.7-191.3-99.2-299-94.6c-224.1,9.7-413,181.4-401.2,399.1 c9.8,124.7,80.1,236.7,188.1,299.7c42.1,25.3,89.2,41.1,138,46.5c12.6,1.2,25.3,1.7,38.1,1.6c-157.3-5.4-292.4-145.9-301.4-302.2 c-10.6-190.6,155.6-340,349.6-348.2c81.8-3.1,162.6,18.6,231.9,62.3L877,153.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShellsIconWhite);
export default __webpack_public_path__ + "static/media/shells_icon_white.6ab594e5508054c9b392dbc600cd6fa9.svg";
export { ForwardRef as ReactComponent };